/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = {
  name: "EditItemDialog",
  props: ["reasons", "item", "remarksReqd"],
  emits: ["set"],
  data: () => {
    return {
      qty: 0,
      reason: "",
      remarks: "",
      touched: false,
    };
  },
  methods: {
    onQtyKeyUp() {
      if (isNaN(this.qty)) this.qty = 0;
      this.qty = Math.max(this.qty, 0);
      this.qty = Math.min(this.qty, this.item.qty);
    },
    onSetItemQty() {
      if (this.qty === this.item.qty) {
        this.reason = "";
      }
      this.touched = true;
      if (this.reasonReqd && !this.reason) {
        return;
      }
      const payload = {
        qty: this.qty,
        reason: this.reason,
        remarks: this.remarks,
      };
      $("#editItemDialog").modal("hide");
      this.$emit("set", payload);
    },
  },
  watch: {
    item(newVal, oldVal) {
      this.touched = false;
      if (newVal) {
        this.qty =
          newVal.completed_qty !== 0 ? newVal.completed_qty : newVal.qty;
        this.reason = newVal.reject_reason;
        this.remarks = newVal.remarks;
      } else {
        this.qty = 0;
        this.reason = "";
        this.remarks = "";
      }
    },
  },
  computed: {
    reasonReqd() {
      return this.qty < this.item.qty;
    },
  },
};

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "editItemDialog",
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "editItemDialogLabel",
        "aria-hidden": "true"
      }
    },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content" }, [
          _vm._m(0),
          _vm._v(" "),
          _vm.item
            ? _c(
                "div",
                {
                  staticClass: "modal-body",
                  class: { "was-validated": _vm.touched }
                },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "completedQty" } }, [
                      _vm._v("Completed Qty")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.qty,
                          expression: "qty"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "number",
                        name: "completedQty",
                        id: "completedQty",
                        max: _vm.item.qty,
                        min: "0"
                      },
                      domProps: { value: _vm.qty },
                      on: {
                        keyup: _vm.onQtyKeyUp,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.qty = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _vm.reasonReqd
                    ? _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "rejectReason" } }, [
                          _vm._v("Reject Reason")
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.reason,
                                expression: "reason"
                              }
                            ],
                            staticClass: "custom-select",
                            attrs: {
                              name: "rejectReason",
                              id: "rejectReason",
                              required: _vm.reasonReqd
                            },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.reason = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }),
                            _vm._v(" "),
                            _vm._l(_vm.reasons, function(reason) {
                              return _c(
                                "option",
                                { domProps: { value: reason.name } },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(reason.name) +
                                      "\n            "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.remarksReqd
                    ? _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "remarks" } }, [
                          _vm._v("Remarks")
                        ]),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.remarks,
                              expression: "remarks"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            name: "remarks",
                            id: "remarks",
                            cols: "30",
                            rows: "5"
                          },
                          domProps: { value: _vm.remarks },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.remarks = $event.target.value
                            }
                          }
                        })
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button", "data-dismiss": "modal" }
              },
              [_vm._v("\n          Close\n        ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: { click: _vm.onSetItemQty }
              },
              [_vm._v("\n          Set\n        ")]
            )
          ])
        ])
      ])
    ]
  )
}
var __vue_staticRenderFns__ = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h5",
        { staticClass: "modal-title", attrs: { id: "editItemDialogLabel" } },
        [_vm._v("\n          Completed Quantity\n        ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  }
]
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../mesrajaya/mesrajaya/public/js/delivery_trip_web/components/EditItemDialog.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__